export const RESET_PASSWORD_COOLDOWN_MS = 60000;
export const RESET_PASSWORD_COOLDOWN_KEY = "resetPasswordCooldownUntil";
export const NORTH_AMERICAN_PHONE_REGEX = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
